/** route 템플릿 산출 — LCP custom 메트릭의 page dimension(`@context.page_template`) 용. */
function contentSectionTemplate(
  pathname: string,
  section: 'blog' | 'news',
): string | null {
  const base = `/${section}`;
  if (pathname === base || !pathname.startsWith(`${base}/`)) return null;
  if (pathname === `${base}/search`) return `${base}/search`;
  // category 는 페이지네이션 유무(/category/<cat>, /category/<cat>/<page>)를 한 템플릿으로 묶음
  if (new RegExp(`^${base}/category/[^/]+(?:/[^/]+)?$`).test(pathname))
    return `${base}/category/:category`;
  if (new RegExp(`^${base}/author/[^/]+/[^/]+$`).test(pathname))
    return `${base}/author/:author/:page`;
  // 실제 포스트만 — category/author/search 는 위 규칙과 lookahead 로 제외
  if (
    new RegExp(`^${base}/(?!(?:category|author|search)$)[^/]+$`).test(pathname)
  )
    return `${base}/:slug`;
  return pathname;
}

export function toPageTemplate(pathname: string): string {
  for (const section of ['blog', 'news'] as const) {
    const template = contentSectionTemplate(pathname, section);
    if (template) return template;
  }
  if (/^\/gene-browser\/gene\/[^/]+$/.test(pathname))
    return '/gene-browser/gene/:geneId';
  return pathname;
}

/** 전체 URL → page_template. 로케일은 en·ko 뿐이라 `/ko` 만 떼면 로케일 무관 템플릿이 된다. */
export function pageTemplateFromUrl(url: string): string {
  let pathname: string;
  try {
    pathname = new URL(url).pathname;
  } catch {
    return url;
  }
  const localePath = pathname.replace(/^\/ko(?=\/|$)/, '') || '/';
  return toPageTemplate(localePath);
}
